// import React, { useEffect } from 'react';
// import './ConferenceSchedule.css';
// import Navbar from './Navbar';
// import Footer from './Footer';

// const ConferenceSchedule = () => {
//   useEffect(() => {
//     window.scrollTo({
//       top: 0,
//       behavior: 'smooth'
//     });
//   }, []);

//   return (
//     <>
//         <Navbar />
//     <div className="conference-schedule-container">
//       <div className="schedule-box">
//         <h1 className="schedule-heading">Conference Schedule</h1>
//         <p className="schedule-message">
//           The detailed conference schedule is currently being finalized.<br />
//           Please stay tuned — it will be published closer to the event.
//         </p>
//         <p className="schedule-note">We appreciate your patience and enthusiasm!</p>
//       </div>
//     </div>
//     <br />
//     <br />
//     <Footer />
//     </>
//   );
// };

// export default ConferenceSchedule;

import React, { useEffect, useState } from 'react';
import './ConferenceSchedule.css';
import Navbar from './Navbar';
import Footer from './Footer';

const ConferenceSchedule = () => {
  const [showInlineViewer, setShowInlineViewer] = useState(true);
  const [iframeError, setIframeError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  // Add cache-busting parameter to force browsers to fetch the latest PDF
  // Increment this version number whenever the PDF is updated
  const pdfVersion = 'v4';
  const pdfUrl = `/stis2025/assets/schd.pdf?v=${pdfVersion}`;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  useEffect(() => {
    // Set a timeout to detect if PDF fails to load
    if (showInlineViewer && isLoading) {
      const timeout = setTimeout(() => {
        // Check if iframe is still loading after 8 seconds
        if (isLoading) {
          setIframeError(true);
          setIsLoading(false);
        }
      }, 8000);

      return () => clearTimeout(timeout);
    }
  }, [showInlineViewer, isLoading]);

  const handleIframeLoad = () => {
    setIsLoading(false);
    setIframeError(false);
  };

  const handleIframeError = () => {
    setIsLoading(false);
    setIframeError(true);
  };

  // Reset states when toggling viewer
  useEffect(() => {
    if (showInlineViewer) {
      setIsLoading(true);
      setIframeError(false);
    }
  }, [showInlineViewer]);

  return (
    <>
      <Navbar />

      {/* ✅ Heading OUTSIDE the container */}
      <div className="schedule-page-heading">
        Final Program Schedule for STIS-V 2025
      </div>

      <div className="conference-schedule-container">
        <div className="schedule-box">

          <div className="schedule-actions">
            <a className="btn btn-primary" href={pdfUrl} download>
              Download PDF
            </a>

            <a className="btn btn-secondary" href={pdfUrl} target="_blank" rel="noopener noreferrer">
              Open in new tab
            </a>

            <button className="btn btn-outline" onClick={() => setShowInlineViewer(v => !v)}>
              {showInlineViewer ? 'Hide inline view' : 'Show inline view'}
            </button>
          </div>

          {showInlineViewer && (
            <div className="pdf-viewer-wrap">
              {isLoading && !iframeError && (
                <div className="pdf-loading">
                  <div className="loading-spinner"></div>
                  <p>Loading schedule...</p>
                </div>
              )}
              
              {iframeError ? (
                <div className="pdf-fallback">
                  <div className="fallback-content">
                    <h3>⚠️ Unable to display PDF inline</h3>
                    <p>The PDF viewer is not available in your browser. Please use one of the options below:</p>
                    <div className="fallback-actions">
                      <a className="btn btn-primary" href={pdfUrl} download>
                        Download PDF
                      </a>
                      <a className="btn btn-secondary" href={pdfUrl} target="_blank" rel="noopener noreferrer">
                        Open in new tab
                      </a>
                    </div>
                    <p className="fallback-note">
                      <small>This may happen if your browser doesn't support inline PDF viewing or has security restrictions.</small>
                    </p>
                  </div>
                </div>
              ) : (
                <iframe
                  title="Final STIS-V 2025 Schedule"
                  src={`${pdfUrl}#toolbar=1&navpanes=0&scrollbar=1`}
                  className="pdf-iframe"
                  onLoad={handleIframeLoad}
                  onError={handleIframeError}
                  style={{ display: isLoading ? 'none' : 'block' }}
                />
              )}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ConferenceSchedule;
